import React from 'react';

const ScormIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
        >
            <g
                fill="currentcolor"
                data-name="Group 6690"
                transform="translate(-623.147 -1037.175)"
            >
                <path
                    d="M632.092 1050.953a1.789 1.789 0 00-1.247.445 1.539 1.539 0 00-.492 1.186 1.488 1.488 0 00.473 1.17 3.637 3.637 0 00.982.612 1.538 1.538 0 01.616.37.648.648 0 01.1.383.6.6 0 01-.1.357.362.362 0 01-.316.118.583.583 0 01-.454-.158.906.906 0 01-.15-.6v-.126h-1.285v.126a1.922 1.922 0 00.279 1.075 1.731 1.731 0 00.715.625 2.106 2.106 0 00.895.2 1.751 1.751 0 001.237-.427 1.558 1.558 0 00.463-1.2 1.705 1.705 0 00-.384-1.155 2.717 2.717 0 00-1.109-.708 2.336 2.336 0 01-.521-.318.431.431 0 01-.164-.344.573.573 0 01.112-.363.383.383 0 01.328-.131.373.373 0 01.346.159.9.9 0 01.119.486v.127h1.281v-.127a1.806 1.806 0 00-.47-1.28 1.648 1.648 0 00-1.254-.502z"
                    data-name="Path 7099"
                    transform="translate(-3.494 -6.802)"
                ></path>
                <path
                    d="M640.281 1052.339a.5.5 0 01.469-.238.533.533 0 01.454.16 1.36 1.36 0 01.147.718v.123h1.285l-.008-.135a2.421 2.421 0 00-.521-1.485 1.932 1.932 0 00-2.773.1 2.808 2.808 0 00-.509 1.8v.966a2.8 2.8 0 00.5 1.752 1.706 1.706 0 001.4.627 1.8 1.8 0 001.364-.516 2.191 2.191 0 00.525-1.476l.005-.131h-1.282v.123a1.164 1.164 0 01-.154.7.581.581 0 01-.453.149.473.473 0 01-.481-.25 2.573 2.573 0 01-.145-1.028v-.978a2.108 2.108 0 01.177-.981z"
                    data-name="Path 7100"
                    transform="translate(-7.742 -6.798)"
                ></path>
                <path
                    d="M651.143 1051.59a1.908 1.908 0 00-2.847 0 2.774 2.774 0 00-.537 1.839v.894a2.631 2.631 0 00.542 1.8 1.825 1.825 0 001.424.615 1.807 1.807 0 001.42-.616 2.654 2.654 0 00.536-1.795v-.894a2.773 2.773 0 00-.538-1.843zm-2.1 1.8a2.044 2.044 0 01.189-1.01.582.582 0 01.983.005 2.091 2.091 0 01.188 1.034v.927a1.91 1.91 0 01-.187.967.536.536 0 01-.487.259.55.55 0 01-.5-.265 1.923 1.923 0 01-.188-.987z"
                    data-name="Path 7101"
                    transform="translate(-12.15 -6.802)"
                ></path>
                <path
                    d="M633.147 1037.175a10 10 0 1010 10 10.011 10.011 0 00-10-10zm0 18.228a8.228 8.228 0 118.228-8.228 8.237 8.237 0 01-8.228 8.225z"
                    data-name="Path 7102"
                ></path>
            </g>
        </svg>
    );
};

export default ScormIcon;
